<template>
  <div class="mt-7">
    <slot name="components" />
    <div class="mt-6 w-full">
      <ul role="list" class="flex flex-col space-y-4">
        <slot name="list-items" />
      </ul>
    </div>
  </div>
</template>
